module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_InvertedBadges_116x116_1-9e2b2d3f9ec79e7b1b4786d1ce125ed1.png";